import type { Store } from 'redux';
import type { Epic } from 'redux-observable';
import initiateStore from '@atlassian/jira-common-tangerine/src/state/initiate.tsx';
import type { Action } from './actions.tsx';
import rootReducer from './reducer.tsx';
import type { State } from './types.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (rootEpic?: Epic<Action, State>): Store<State> =>
	initiateStore<State, Action, undefined>({
		appName: 'directories/filters-v2/delete-modal',
		rootReducer,
		rootEpic,
	});
